import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormRequerimentosComponent } from './form-requerimentos/form-requerimentos.component';


const routes: Routes = [
    {path:"requerimentos/:id", component: FormRequerimentosComponent}
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class RequerimentosRoutingModule { }
